const { append, assoc, curry, propEq, update } = require('rambda')

export default curry((reviewsExternal, laptop) => {
  const merged = laptop
    .reviewsExternal
    .reduce((reviews, review) => {
      const index = reviews.findIndex(propEq('url', review.url))

      return index === -1
        ? append(review, reviews)
        : update(index, review, reviews)
    }, reviewsExternal)

  return assoc('reviewsExternal', merged, laptop)
})
